

import React from 'react';
import logo from '../ginkgo.png';
import { withRouter } from "react-router-dom";
import { 
  DollarCircleOutlined, 
  TeamOutlined, 
  BankOutlined, 
  TrophyOutlined 
} from '@ant-design/icons';

import '../App.css';
import axios from 'axios';
import { baseURL } from '../API/url';
import { sessionManager, setupAxiosInterceptors } from '../utils/sessionManager';
import moment from 'moment';
import dayjs from 'dayjs';
import RedemptionPoolChart, {
  getActiveRedemptionTotal,
} from './RedemptionPoolChart';
import RedemptionRequestTable from './RedemptionRequestTable';
import RedemptionBookingTable from './RedemptionBookingTable';
import { buildListHeader } from '../utils/listSummary';
import { 
  Form, 
  DatePicker, 
  Button, 
  Typography, 
  Card, 
  Row, 
  Col, 
  Table, 
  Statistic, 
  Tabs, 
  Select,
  Space,
  Descriptions,
  Divider,
  Modal,
  Input,
  Collapse,
  Radio
} from 'antd';
const { RangePicker } = DatePicker;

const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const dateFormat = 'MM-DD-YYYY';
const DB_dateFormat = 'YYYY-MM-DD';

const getDefaultRedemptionPeriod = () => {
  const target = moment();
  return {
    month: target.month(),
    year: target.year(),
  };
};

interface EMDState {
  isAuthenticated: any;
  loading: boolean;
  advisors: any[];
  selectedAdvisorId: string | null;
  selectedAdvisor: any | null;
  advisorClients: any[];
  advisorAssets: any[];
  emdSummary: {
    totalAdvisors: number;
    totalClients: number;
    totalAssets: string;
    advisorSummary: any[];
  };
  activeTab: string;
  // Modal states
  isAdvisorListModalOpen: boolean;
  advisorSearchText: string;
  // EMD info
  emdInfo: any | null;
  // Transaction and certificate data
  transactionData: any[];
  certData: any[];
  commData: any[];
  redeemData: any[];
  certDataAdvisor: any[];
  commDataAdvisor: any[];
  transactionStartDate: string;
  transactionEndDate: string;
  certStartDate: string;
  certEndDate: string;
  partnersData: any[];
  currentAccountRecId: string;
  totalAccountValue: any[];
  totalAccountsValue: number;
  totalAccountTrailerFees: number;
  totalAccountsTrailerFees: number;
  certTrailerFees: any[];
  displayAccountNum: string;
  displayAdvisorType: string;
  transactionProductId: string;
  certificateProductId: string;
  certificateProductName: string;
  partner: any;
  certSub_total: number;
  selectedYear: string;
  subTotalFeesOnYears: Array<{year: number; total: number}>;
  selectedYearCommTotal: number[];
  currentMonthFeesTotal: string;
  currentYear: number;
  currentMonth: number;
  isModalOpen: boolean;
  selectedPartnerSin: string;
  clientListData: any[];
  clientList: any[];
  userId: string;
  advisorId: string;
  userType: string;
  totalClient: number;
  totalAsset: number;
  clientTotalValue: number;
  selectedCommMonth: number;
  selectedCommYear: string;
  searchText: string;
  // Redemption report modal states
  isRedemptionReportModalOpen: boolean;
  selectedReportMonth: string;
  // Commission report modal states
  isCommissionReportModalOpen: boolean;
  selectedCommissionMonth: string;
  // Decoded SIN
  decodedSin: string;
  // Redemption request section (below the pool charts)
  redemptionMonth: number;
  redemptionYear: number;
  dripTotal: number;
  newPurchaseTotal: number;
  redemptionRecords: any[];
  redemptionLoading: boolean;
  bookingRecords: any[];
  bookingLoading: boolean;
  totalMatch: number;
  totalNonMatch: number;
  totalRetracted: number;
  matchPeriodAllocated: number;
}

// Static sample rows shown in the Redemption Requests table when the database
// has no records for the selected month/year (so the editable table + Edit
// buttons are always visible).
const STATIC_REDEMPTION_ROWS = [
  {
    recId: 'static-1',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Annisa Ng',
    account: 'ONTF180249',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 140361.00,
    dateRequest: '2026-06-02',
    queueNumber: 1,
    status: 'Matched',
  },
  {
    recId: 'static-2',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Libo Wang',
    account: 'FOR00090',
    advisorName: 'Angel Lin',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 250000.00,
    dateRequest: '2026-06-05',
    queueNumber: 2,
    status: 'Matched',
  },
  {
    recId: 'static-3',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yen Fang Huang',
    account: 'FOR00124',
    advisorName: 'Raymond Keung',
    emdFirm: 'Waverley',
    amount: 65502.00,
    dateRequest: '2026-06-06',
    queueNumber: 3,
    status: 'Matched',
  },
  {
    recId: 'static-4',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Qian Wang',
    account: 'BCTF340952',
    advisorName: 'Ralph He',
    emdFirm: 'Raisen Pacific Wealth',
    amount: 24693.72,
    dateRequest: '2026-06-07',
    queueNumber: 4,
    status: 'Matched',
  },
  {
    recId: 'static-5',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yanzhen Jia/ Qifei Bo',
    account: 'ON00265',
    advisorName: 'Luyang Yan',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 50500.00,
    dateRequest: '2026-06-08',
    queueNumber: 5,
    status: 'Matched',
  },
  {
    recId: 'static-6',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Kindson International Inc.',
    account: 'OCORP00038',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 100500.00,
    dateRequest: '2026-06-09',
    queueNumber: 6,
    status: 'Matched',
  },
  {
    recId: 'static-7',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Alex Yuen',
    account: 'ONRF255546',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 15000.00,
    dateRequest: '2026-06-09',
    queueNumber: 7,
    status: 'Matched',
  },
  {
    recId: 'static-8',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Ping Fu MPC',
    account: 'OCORP00006',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 1000000.00,
    dateRequest: '2026-06-09',
    queueNumber: 8,
    status: 'Matched',
  },
  {
    recId: 'static-9',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lian Rong Liu',
    account: 'FOR00097',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 200000.00,
    dateRequest: '2026-06-11',
    queueNumber: 9,
    status: 'Pending',
  },
  {
    recId: 'static-10',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Edward Kirkland Feng Xiao',
    account: 'BC00149',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 10000.00,
    dateRequest: '2026-06-11',
    queueNumber: 10,
    status: 'Pending',
  },
  {
    recId: 'static-11',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BC00213',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 19605.61,
    dateRequest: '2026-06-11',
    queueNumber: 11,
    status: 'Pending',
  },
  {
    recId: 'static-12',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BCTF133760',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 32894.88,
    dateRequest: '2026-06-14',
    queueNumber: 12,
    status: 'Pending',
  },
  {
    recId: 'static-13',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tina Tsiao Nien Tso',
    account: 'BC00239',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 3697.77,
    dateRequest: '2026-06-15',
    queueNumber: 13,
    status: 'Pending',
  },
  {
    recId: 'static-14',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tuen Yee Phyllis Chan',
    account: 'BCRF253493',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 7415.32,
    dateRequest: '2026-06-15',
    queueNumber: 14,
    status: 'Pending',
  },
  {
    recId: 'static-15',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Chee Chung Cheung',
    account: 'BC00209',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 50000.00,
    dateRequest: '2026-06-15',
    queueNumber: 15,
    status: 'Pending',
  },
  {
    recId: 'static-16',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCRS142731',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 7000.00,
    dateRequest: '2026-06-16',
    queueNumber: 16,
    status: 'Pending',
  },
  {
    recId: 'static-17',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCTF142729',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 6700.00,
    dateRequest: '2026-06-16',
    queueNumber: 17,
    status: 'Pending',
  },
  {
    recId: 'static-18',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Cheng Hsu',
    account: 'BC00123',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 40000.00,
    dateRequest: '2026-06-18',
    queueNumber: 18,
    status: 'Pending',
  },
  {
    recId: 'static-19',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lin Jiang',
    account: 'ONTF207291',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 60000.00,
    dateRequest: '2026-06-19',
    queueNumber: 19,
    status: 'Pending',
  },
  {
    recId: 'static-20',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Jian Xiong Wang',
    account: 'BCRS143966',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 23168.32,
    dateRequest: '2026-06-21',
    queueNumber: 20,
    status: 'Pending',
  },
  {
    recId: 'static-21',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Janet Lui',
    account: 'BCTF208115',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 80000.00,
    dateRequest: '2026-06-21',
    queueNumber: 21,
    status: 'Pending',
  },
  {
    recId: 'static-22',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Samuel Wong',
    account: 'ONTF173133',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc.',
    amount: 7000.00,
    dateRequest: '2026-06-26',
    queueNumber: 22,
    status: 'Pending',
  }
];


class PortfolioEMD extends React.Component<any, EMDState> {
  constructor(props: any) {
    super(props);
    const defaultRedemptionPeriod = getDefaultRedemptionPeriod();
    
    this.state = {
      isAuthenticated: props.isAuthenticated,
      loading: true,
      advisors: [],
      selectedAdvisorId: null,
      selectedAdvisor: null,
      advisorClients: [],
      advisorAssets: [],
      emdSummary: {
        totalAdvisors: 0,
        totalClients: 0,
        totalAssets: '$0.00',
        advisorSummary: []
      },
      activeTab: 'summary',
      // Modal states
      isAdvisorListModalOpen: false,
      advisorSearchText: '',
      // EMD info
      emdInfo: null,
      transactionData: [],
      certData: [],
      commData: [],
      redeemData: [],
      certDataAdvisor: [],
      commDataAdvisor: [],
      transactionStartDate: moment().dayOfYear(1).format(dateFormat),
      transactionEndDate: moment().format(dateFormat),
      certStartDate: moment().dayOfYear(1).format(dateFormat),
      certEndDate: moment().format(dateFormat),
      partnersData: [],
      currentAccountRecId: '',
      totalAccountValue: [],
      totalAccountsValue: 0,
      totalAccountTrailerFees: 0,
      totalAccountsTrailerFees: 0,
      certTrailerFees: [],
      displayAccountNum: '',
      displayAdvisorType: '',
      transactionProductId: '',
      certificateProductId: '',
      certificateProductName: '',
      partner: {},
      certSub_total: 0,
      selectedYear: moment().dayOfYear(1).format(dateFormat),
      subTotalFeesOnYears: [
        {year: moment().subtract(9, "years").year(), total: 0}, 
        {year: moment().subtract(8, "years").year(), total: 0}, 
        {year: moment().subtract(7, "years").year(), total: 0}, 
        {year: moment().subtract(6, "years").year(), total: 0}, 
        {year: moment().subtract(5, "years").year(), total: 0}, 
        {year: moment().subtract(4, "years").year(), total: 0},
        {year: moment().subtract(3, "years").year(), total: 0}, 
        {year: moment().subtract(2, "years").year(), total: 0}, 
        {year: moment().subtract(1, "years").year(), total: 0}, 
        {year: moment().year(), total: 0}
      ],
      selectedYearCommTotal: [0,0,0,0,0],
      /* currentMonthFeesTotal: 0, */
      currentMonthFeesTotal: '',
      currentYear: moment().year(),
      currentMonth: moment().month(),
      isModalOpen: false,
      selectedPartnerSin: '',
      clientListData: [],
      clientList: [],
      userId: '',
      advisorId: '',
      userType: '',
      totalClient: 0,
      totalAsset: 0,
      clientTotalValue: 0,
      // selectedCommMonth: '2',
      selectedCommMonth: moment().subtract(1, 'months').month(),
      selectedCommYear: moment().format('YYYY'),
      searchText: '',
      // Redemption report modal states
      isRedemptionReportModalOpen: false,
      selectedReportMonth: (() => {
        const currentDay = moment().date();
        if (currentDay >= 18) {
          return moment().subtract(1, 'months').format('YYYY-MM');
        } else {
          return moment().subtract(2, 'months').format('YYYY-MM');
        }
      })(),
      // Commission report modal states
      isCommissionReportModalOpen: false,
      selectedCommissionMonth: (() => {
        const currentDay = moment().date();
        if (currentDay >= 18) {
          return moment().subtract(1, 'months').format('YYYY-MM');
        } else {
          return moment().subtract(2, 'months').format('YYYY-MM');
        }
      })(),
      // Decoded SIN
      decodedSin: '',
      // Redemption request section
      redemptionMonth: defaultRedemptionPeriod.month,
      redemptionYear: defaultRedemptionPeriod.year,
      dripTotal: 0,
      newPurchaseTotal: 0,
      redemptionRecords: [],
      redemptionLoading: false,
      bookingRecords: [],
      bookingLoading: false,
      totalMatch: 0,
      totalNonMatch: 0,
      totalRetracted: 0,
      matchPeriodAllocated: 0,
    };
  }

  componentDidMount = async () => {

    console.log('PortfolioEMD componentDidMount - This should load for EMD users!');
    console.log('PortfolioEMD - isAuthenticated:', this.state.isAuthenticated);
    
    // Setup axios interceptors for session management
    setupAxiosInterceptors(axios);
    
    // Check if user is authenticated, if not redirect to login
    if (!this.state.isAuthenticated) {
      this.props.history.push('/login');
      return;
    }

    // Verify that the authentication data contains required information
    if (!Array.isArray(this.state.isAuthenticated) || !this.state.isAuthenticated[1]) {
      console.error('Invalid authentication data structure');
      this.props.history.push('/login');
      return;
    }

    try {
      // Get user email from authentication props
      const userEmail = this.state.isAuthenticated[1]; // Email is the second element in the array
      console.log('PortfolioEMD: Loading data for user email:', userEmail);
      await Promise.all([
        this.fetchInitialRedemptionRecordsByEmail(userEmail),
        this.fetchBookingRecords(),
        this.fetchMatchingFundPool(),
        this.fetchMatchSummary(),
        this.loadEMDDataByEmail(userEmail),
      ]);
      
      // After loading EMD data, check if we have a selected advisor and load their client data
      if (this.state.selectedAdvisor && this.state.selectedAdvisor.email) {
        await this.loadAdvisorData(userEmail, this.state.selectedAdvisor.email);
      }
    } catch (error: any) {
      console.error('Error loading EMD data:', error);
      console.error('Error response:', error.response);
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      
      // Display user-friendly error message
      if (error.response && error.response.status === 404) {
        console.warn(`EMD not found for user email: ${this.state.isAuthenticated[1]}`);
        alert(`No EMD record found for your email address: ${this.state.isAuthenticated[1]}. Please contact support.`);
      }
      
      // If there's an authentication error, log it but don't immediately redirect
      // Let individual API calls handle their own 401 errors
      if (error.response && error.response.status === 401) {
        console.warn('Authentication error in componentDidMount, but continuing to load page');
        // Don't redirect immediately - let individual API calls handle their auth errors
        // this.props.history.push('/login');
        // return;
      }
      this.setState({ loading: false });
    }
  };

  fetchMatchingFundPool = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/matchingfundpool?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        dripTotal: Number(response.data?.dripTotal) || 0,
        newPurchaseTotal: Number(response.data?.newPurchaseTotal) || 0,
      });
    } catch (error) {
      console.error('Error fetching matching fund pool:', error);
      this.setState({ dripTotal: 0, newPurchaseTotal: 0 });
    }
  };

  fetchMatchSummary = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/redemptionrequest/match-summary?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        totalMatch: Number(response.data?.totalMatch) || 0,
        totalNonMatch: Number(response.data?.totalNonMatch) || 0,
        totalRetracted: Number(response.data?.totalRetracted) || 0,
        matchPeriodAllocated: Number(response.data?.matchPeriodAllocated) || 0,
      });
    } catch (error) {
      console.error('Error fetching redemption match summary:', error);
      this.setState({ totalMatch: 0, totalNonMatch: 0, totalRetracted: 0, matchPeriodAllocated: 0 });
    }
  };

  // Build session auth headers
  getAuthHeaders = () => {
    const sessionToken = sessionManager.getSessionToken();
    return sessionToken
      ? { headers: { Authorization: `Bearer ${sessionToken}` } }
      : {};
  };

  // Fetch redemption requests for this EMD only (read-only)
  fetchRedemptionRecords = async (emdId?: string, emdFirm?: string) => {
    const effectiveEmdId = emdId || this.state.emdInfo?.recId;
    const effectiveEmdFirm = emdFirm || this.state.emdInfo?.firm;
    if (!effectiveEmdId && !effectiveEmdFirm) {
      this.setState({ redemptionRecords: [] });
      return;
    }
    this.setState({ redemptionLoading: true });
    try {
      const month = this.state.redemptionMonth + 1; // backend expects 1-based month
      const year = this.state.redemptionYear;
      const emdIdQuery = effectiveEmdId ? `&emdId=${encodeURIComponent(effectiveEmdId)}` : '';
      const emdFirmQuery = effectiveEmdFirm
        ? `&emdFirm=${encodeURIComponent(effectiveEmdFirm)}`
        : '';
      const response = await axios.get(
        `${baseURL}/redemptionrequest/list?month=${month}&year=${year}${emdIdQuery}${emdFirmQuery}`,
        this.getAuthHeaders(),
      );
      this.setState({ redemptionRecords: response.data || [], redemptionLoading: false });
    } catch (error) {
      console.error('Error fetching redemption records:', error);
      this.setState({ redemptionRecords: [], redemptionLoading: false });
    }
  };

  fetchInitialRedemptionRecordsByEmail = async (userEmail: string) => {
    try {
      const response = await axios.get(
        `${baseURL}/emd/by-email/${encodeURIComponent(userEmail)}`,
        this.getAuthHeaders(),
      );
      const emdId = response.data?.recId;
      const emdFirm = response.data?.firm;
      if (emdId || emdFirm) {
        await this.fetchRedemptionRecords(emdId, emdFirm);
      }
    } catch (error) {
      console.error('Error fetching initial EMD redemption records:', error);
    }
  };

  handleRedemptionPeriodChange = (month: number, year: number) => {
    this.setState({ redemptionMonth: month, redemptionYear: year }, () =>
      Promise.all([
        this.fetchRedemptionRecords(),
        this.fetchMatchingFundPool(),
        this.fetchMatchSummary(),
      ]),
    );
  };

  getFilteredRedemptionRows = (): any[] => {
    return this.state.redemptionRecords || [];
  };

  // Bookings are scoped to this EMD firm by the server; no filters are sent.
  fetchBookingRecords = async () => {
    this.setState({ bookingLoading: true });
    try {
      const response = await axios.get(
        `${baseURL}/redemptionbooking/list`,
        this.getAuthHeaders(),
      );
      this.setState({
        bookingRecords: response.data || [],
        bookingLoading: false,
      });
    } catch (error) {
      console.error('Error fetching redemption bookings:', error);
      this.setState({ bookingRecords: [], bookingLoading: false });
    }
  };

  getRedemptionByFirm = (): Array<{ firm: string; amount: number }> => {
    const totals: { [firm: string]: number } = {};
    (this.state.redemptionRecords || [])
      .filter((r: any) =>
        r.status === 'Matched' ||
        r.status === 'Completed' ||
        r.status === 'Redeemed',
      )
      .forEach((r: any) => {
      const firm = r.emdFirm || 'Unknown';
      totals[firm] = (totals[firm] || 0) + (Number(r.amount) || 0);
      });
    return Object.keys(totals).map((firm) => ({ firm, amount: totals[firm] }));
  };

  getTotalRedemption = (): number =>
    getActiveRedemptionTotal(this.state.redemptionRecords || []);

  loadEMDDataByEmail = async (userEmail: string) => {
    this.setState({ loading: true });
    
    console.log('loadEMDDataByEmail: Starting data load for:', userEmail);
    
    try {
      // Get session token for authorization
      const sessionToken = sessionManager.getSessionToken();
      const authHeaders = sessionToken ? {
        headers: {
          Authorization: `Bearer ${sessionToken}`
        }
      } : {};

      // Use Promise.all to load EMD data in parallel using the user's email
      console.log('Making API calls to EMD endpoints...');
      const [summaryResponse, advisorsResponse, emdInfoResponse] = await Promise.all([
        axios.get(`${baseURL}/emd/summary/by-email/${encodeURIComponent(userEmail)}`, authHeaders),
        axios.get(`${baseURL}/emd/advisors/by-email/${encodeURIComponent(userEmail)}`, authHeaders),
        axios.get(`${baseURL}/emd/by-email/${encodeURIComponent(userEmail)}`, authHeaders)
      ]);
      console.log('summaryResponse:', summaryResponse.data);
      console.log('advisorsResponse:', advisorsResponse.data);
      console.log('emdInfoResponse:', emdInfoResponse.data);
      const emdSummary = summaryResponse.data || {
        totalAdvisors: 0,
        totalClients: 0,
        totalAssets: '$0.00',
        advisorSummary: []
      };
      
      const advisors = advisorsResponse.data || [];
      const emdInfo = emdInfoResponse.data || null;
      
      this.setState({ 
        emdSummary,
        advisors,
        emdInfo
      });

      // Load redemption requests for this EMD (read-only)
      this.fetchRedemptionRecords(emdInfo?.recId);

      // Automatically select the advisor with the most clients if available
      if (advisors.length > 0) {
        // Find the advisor with the highest client count
        const advisorWithMostClients = advisors.reduce((maxAdvisor, currentAdvisor) => {
          const maxClientCount = maxAdvisor.clientCount || 0;
          const currentClientCount = currentAdvisor.clientCount || 0;
          return currentClientCount > maxClientCount ? currentAdvisor : maxAdvisor;
        });
        
        this.setState({ 
          selectedAdvisorId: advisorWithMostClients.advisorId,
          selectedAdvisor: advisorWithMostClients
        });
        console.log('Advisor with most clients selected:', advisorWithMostClients);
        
        // Load the selected advisor's data including client list
        await this.handleAdvisorSelect(advisorWithMostClients.advisorId, false);
        if (advisorWithMostClients.email) {
          await this.loadAdvisorData(userEmail, advisorWithMostClients.email);
        }
      }

    } catch (error: any) {
      console.error('Error loading EMD data by email:', error);
      console.error('Error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        userEmail: userEmail
      });
      
      // Set empty data on error
      this.setState({ 
        emdSummary: {
          totalAdvisors: 0,
          totalClients: 0,
          totalAssets: '0.00',
          advisorSummary: []
        },
        advisors: [],
        emdInfo: null
      });
    }
    
    this.setState({ loading: false });
  };

  	loadAdvisorData = async (userEmail: string, advisorEmail: string) => {
		// Check if advisor email is provided
		if (!advisorEmail) {
			console.error('No advisor email provided to loadAdvisorData');
			return;
		}

		if (!userEmail) {
			console.error('No user email provided to loadAdvisorData');
			return;
		}

		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		const authHeaders = sessionToken ? {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		} : {};

		let partnersQuery = ''
		console.log('Loading advisor data for user:', userEmail, 'and advisor:', advisorEmail, 'with authHeaders:', authHeaders);
		
		try {
			console.log('Making API call to:', baseURL + '/user/' + userEmail);
			const user = await axios.get(baseURL + '/user/' + userEmail, authHeaders)  // use provided email parameter
			const advisor = await axios.get(baseURL + '/advisor/' + advisorEmail, authHeaders)  // use provided email parameter
			this.setState({userId: user.data.id, userType: user.data.userType, advisorId: advisor.data.recId})
			console.log('Advisor ID:', this.state.advisorId, 'User ID:', this.state.userId);
			
			const clientFirstTin = await axios.get(baseURL + '/partnertin?advisorId='+advisor.data.recId, authHeaders)
			partnersQuery = '?advisorId='+ advisor.data.recId + '&partnerSin=' + clientFirstTin.data
			const partners = await axios.get(baseURL+"/advisoraccounts"+partnersQuery, authHeaders)
			
			if (partners.data && partners.data.length > 0) {
				this.setState({selectedYear: moment().dayOfYear(1).format(dateFormat)})
				await this.getAccountTrailerFeesTotal(partners.data[0].recId, '')
				await this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
				const cert_data = await this.getCertData(this.state.certStartDate, this.state.certEndDate, partners.data[0].recId, this.state.certificateProductId);
				const transaction_data = await this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, partners.data[0].recId,this.state.transactionProductId);
				const redeem_data = await this.getRedeemData(partners.data[0].recId);
				this.setState({ transactionData: transaction_data.data, certData: cert_data.data, redeemData: redeem_data.data || ''});
				this.setState({partner: partners.data[0], partnersData: partners.data, currentAccountRecId: partners.data[0].recId, displayAccountNum: partners.data[0].account, displayAdvisorType: partners.data[0].advisorType})
				// Decode the SIN for display
				await this.decodeSIN(partners.data[0].tin);
				const commQuery = '?partnerId='+partners.data[0].recId+'&productName='+''
				let comm_data = await axios.get(baseURL+"/commissiondetails"+commQuery, authHeaders)
				this.setState({commData: comm_data.data, selectedYear: moment().dayOfYear(1).format(dateFormat) });
				await this.countTotalAccountsValue(partners.data.map((partnerData:any)=>(partnerData.recId)))
				const advisorCommData = await axios.get(baseURL+'/advisorcommission?email=' + advisorEmail + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear, authHeaders) //use provided email parameter
				this.setState({ commDataAdvisor: advisorCommData.data})
			}

			const clients = await axios.get(baseURL+'/partner/clientList?advisorId='+ advisor.data.recId, authHeaders ) // use provided email parameter
			this.setState({clientListData: clients.data.partners || []})
			this.setState({clientTotalValue: clients.data.clientTotalValue || 0})
			
			const clientsTotalAssets = await axios.post(baseURL+'/advisor/totals?advisorId='+ advisor.data.recId, {}, authHeaders)
			this.setState({totalAsset: clientsTotalAssets.data.totalAssets || 0})
			
			const data: { key: number; firstName: string; lastName: string; emailAddress: string; phone: string; totalValue: string; totalDrip: string; tin: string }[] = [];

			if (clients.data.partners && clients.data.partners.length !== 0) {
				this.setState({ totalClient: clients.data.partners.length });
				for (let i = 0; i < clients.data.partners.length; i++) {
					const client = clients.data.partners[i];
					if ( client.tin!==null )  {
					 if (parseFloat(String(client.clientTotalValue || '0').replace(/[$,]/g, '')) > 0.00 ) {
						// active client
					  data.push({
						key: i,
						firstName: client.firstName,
						lastName: client.advisorType === 'IBP' ? client.lastName + ' *IBP' : client.lastName ,
						emailAddress: client.emailAddress || '',
						phone: client.phoneHome || '',
						totalValue: client.clientTotalValue,
						totalDrip: client.clientTotalDrip,
						tin: client.tin || '',
					})
				}};
				}
			} else {
				this.setState({ totalClient: 0 });
			}
			this.setState({clientList: data})

			const totalValue = await axios.get(baseURL+'/advisorcommissiontotalbymonth?email=' + advisorEmail + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear, authHeaders)
			this.setState({currentMonthFeesTotal: totalValue.data || ''})
		} catch (error) {
			console.error('Error loading advisor data:', error);
			// Clear client data on error
			this.setState({
				clientListData: [],
				clientList: [],
				totalClient: 0,
				totalAsset: 0
			});
		}
	}

  handleAdvisorSelect = async (advisorId: string, setLoading: boolean = true) => {
    if (setLoading) {
      this.setState({ loading: true });
    }
    
    // Find the selected advisor from the advisors list
    const selectedAdvisor = this.state.advisors.find(advisor => advisor.advisorId === advisorId);
    
    this.setState({ 
      selectedAdvisorId: advisorId,
      advisorClients: selectedAdvisor ? selectedAdvisor.advisorClients : [],
      advisorAssets: selectedAdvisor ? selectedAdvisor.advisorAssets : [],
      selectedAdvisor: selectedAdvisor || null
    });
    
    if (setLoading) {
      this.setState({ loading: false });
    }
  };

  // Handle advisor selection from dropdown
  handleAdvisorSelectChange = (advisorId: string) => {
    this.handleAdvisorSelect(advisorId);
  };

  // Modal handlers
  showAdvisorListModal = () => {
    this.setState({ isAdvisorListModalOpen: true });
  };

  handleAdvisorListCancel = () => {
    this.setState({ 
      isAdvisorListModalOpen: false,
      advisorSearchText: ''
    });
  };

  handleAdvisorSearch = (value: string) => {
    this.setState({ advisorSearchText: value });
  };

  // Redemption Report Modal handlers
  showRedemptionReportModal = () => {
    // Set selectedReportMonth to the latest available month based on current day logic
    const currentDay = moment().date();
    let defaultMonth;
    
    if (currentDay >= 18) {
      defaultMonth = moment().subtract(1, 'months').format('YYYY-MM');
    } else {
      defaultMonth = moment().subtract(2, 'months').format('YYYY-MM');
    }
    
    this.setState({ 
      isRedemptionReportModalOpen: true,
      selectedReportMonth: defaultMonth
    });
  };

  handleRedemptionReportCancel = () => {
    this.setState({ isRedemptionReportModalOpen: false });
  };

  handleReportMonthChange = (date: any) => {
    this.setState({ selectedReportMonth: date?.format('YYYY-MM') || moment().format('YYYY-MM') });
  };

  // Commission Report Modal handlers
  showCommissionReportModal = () => {
    // Set selectedCommissionMonth to the latest available month based on current day logic
    const currentDay = moment().date();
    let defaultMonth;
    
    if (currentDay >= 18) {
      defaultMonth = moment().subtract(1, 'months').format('YYYY-MM');
    } else {
      defaultMonth = moment().subtract(2, 'months').format('YYYY-MM');
    }
    
    this.setState({ 
      isCommissionReportModalOpen: true,
      selectedCommissionMonth: defaultMonth
    });
  };

  handleCommissionReportCancel = () => {
    this.setState({ isCommissionReportModalOpen: false });
  };

  handleCommissionMonthChange = (date: any) => {
    this.setState({ selectedCommissionMonth: date?.format('YYYY-MM') || moment().format('YYYY-MM') });
  };

  generateRedemptionReport = async () => {
    const { selectedReportMonth, emdInfo } = this.state;
    
    if (!emdInfo || !emdInfo.firm) {
      console.error('EMD firm information not available');
      alert('EMD firm information not available');
      return;
    }

    if (!selectedReportMonth) {
      alert('Please select a month for the report');
      return;
    }

    try {
      this.setState({ loading: true });
      
      // Format reportDate as YYYY-MM-DD with the last day of the month
      const lastDayOfMonth = moment(selectedReportMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      
      console.log('Generating redemption report for:', { firm: emdInfo.firm, reportDate: lastDayOfMonth });

      // Use the same transaction-based method as the admin report
      // (api/report/redeem/firm -> getAllRedeemByFirm), scoped to this EMD's firm.
      const response = await axios.get(`${baseURL}/report/redeem/firm`, {
        params: {
          firm: emdInfo.firm,
          reportDate: lastDayOfMonth
        },
        headers: {
          Authorization: `Bearer ${sessionManager.getSessionToken()}`,
          'Accept': 'application/json'
        }
      });

      console.log('Response received:', response);
      console.log('Response data:', response.data);

      // Check if we received valid JSON data
      if (!response.data || typeof response.data !== 'object') {
        console.error('Invalid response format:', response.data);
        alert('Invalid response format from server');
        return;
      }

      // Convert JSON data to CSV format for Excel
      const jsonData = response.data;
      let csvContent = '';

      if (Array.isArray(jsonData) && jsonData.length > 0) {
        // Create CSV header from object keys (same columns as the admin report)
        const headers = Object.keys(jsonData[0]);
        csvContent = headers.join(',') + '\n';

        // Add data rows
        jsonData.forEach(row => {
          const values = headers.map(header => {
            let value = row[header];

            // Handle values that might contain commas, quotes, or newlines
            if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value || '';
          });
          csvContent += values.join(',') + '\n';
        });
      } else {
        csvContent = 'No data available for the selected period\n';
      }
      
      // Create blob and download as Excel file
      const blob = new Blob([csvContent], { 
        type: 'text/csv;charset=utf-8;' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Redemption_Report_${emdInfo.firm}_${selectedReportMonth}.csv`;
      link.style.display = 'none';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log('File download initiated successfully');
      this.setState({ isRedemptionReportModalOpen: false });
      
    } catch (error: any) {
      console.error('Error generating redemption report:', error);
      
      // More detailed error handling
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
        
        if (error.response.status === 404) {
          alert('Report endpoint not found. Please check the API configuration.');
        } else if (error.response.status === 500) {
          alert('Server error while generating report. Please try again later.');
        } else {
          alert(`Error generating report: ${error.response.status} - ${error.response.statusText}`);
        }
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No response from server. Please check your connection.');
      } else {
        console.error('Error setting up request:', error.message);
        alert(`Error: ${error.message}`);
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  generateCommissionReport = async () => {
    const { selectedCommissionMonth, emdInfo } = this.state;
    
    if (!emdInfo || !emdInfo.firm) {
      console.error('EMD firm information not available');
      alert('EMD firm information not available');
      return;
    }

    if (!selectedCommissionMonth) {
      alert('Please select a month for the report');
      return;
    }

    try {
      this.setState({ loading: true });
      
      // Format reportDate as YYYY-MM-DD with the last day of the month
      const lastDayOfMonth = moment(selectedCommissionMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      
      console.log('Generating commission report for:', { firm: emdInfo.firm, reportDate: lastDayOfMonth });
      
      const response = await axios.get(`${baseURL}/emd/report/commissions/firm`, {
        params: {
          firm: emdInfo.firm,
          reportDate: lastDayOfMonth
        },
        headers: {
          Authorization: `Bearer ${sessionManager.getSessionToken()}`,
          'Accept': 'application/json'
        }
      });

      console.log('Response received:', response);
      console.log('Response data:', response.data);

      // Check if we received valid JSON data
      if (!response.data || typeof response.data !== 'object') {
        throw new Error('Invalid response format. Expected JSON data.');
      }

      // Convert JSON data to CSV format for Excel
      const jsonData = response.data;
      let csvContent = '';
      
      if (Array.isArray(jsonData) && jsonData.length > 0) {
        // Create CSV headers from the first object's keys
        const headers = Object.keys(jsonData[0]);
        csvContent += headers.join(',') + '\n';
        
        // Add each row of data
        jsonData.forEach(row => {
          const values = headers.map(header => {
            let value = row[header] || '';
            // Handle special characters and wrap in quotes if needed
            if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
              value = '"' + value.replace(/"/g, '""') + '"';
            }
            return value;
          });
          csvContent += values.join(',') + '\n';
        });
      } else {
        alert('No commission data found for the selected month and firm.');
        return;
      }
      
      // Create blob and download as Excel file
      const blob = new Blob([csvContent], { 
        type: 'text/csv;charset=utf-8;' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Commission_Report_${emdInfo.firm}_${selectedCommissionMonth}.csv`;
      link.style.display = 'none';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log('File download initiated successfully');
      this.setState({ isCommissionReportModalOpen: false });
      
    } catch (error: any) {
      console.error('Error generating commission report:', error);
      
      // More detailed error handling
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
        
        if (error.response.status === 404) {
          alert('Commission report endpoint not found. Please check the API configuration.');
        } else if (error.response.status === 500) {
          alert('Server error while generating commission report. Please try again later.');
        } else {
          alert(`Error generating commission report: ${error.response.status} - ${error.response.statusText}`);
        }
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No response from server. Please check your connection.');
      } else {
        console.error('Error setting up request:', error.message);
        alert(`Error: ${error.message}`);
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  // Select advisor from modal
  selectAdvisorFromModal = async (advisor: any) => {
    this.setState({ 
      selectedAdvisorId: advisor.advisorId,
      selectedAdvisor: advisor,
      isAdvisorListModalOpen: false,
      advisorSearchText: '',
      loading: true
    });
    
    try {
      // Load the selected advisor's data including client list
      const userEmail = this.state.isAuthenticated[1];
      await this.loadAdvisorData(userEmail, advisor.email);
      await this.handleAdvisorSelect(advisor.advisorId, false);
      
      console.log('Advisor selected and data loaded:', advisor);
    } catch (error) {
      console.error('Error loading advisor data after selection:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Render advisor list table for modal
  renderAdvisorListTable = () => {
    const { advisors, advisorSearchText } = this.state;
    
    // Filter advisors based on search text
    const filteredAdvisors = advisors.filter(advisor => 
      advisor.advisorName?.toLowerCase().includes(advisorSearchText.toLowerCase()) ||
      advisor.email?.toLowerCase().includes(advisorSearchText.toLowerCase()) ||
      advisor.firm?.toLowerCase().includes(advisorSearchText.toLowerCase())
    );

    const columns = [
      {
        title: 'Advisor Name',
        dataIndex: 'advisorName',
        key: 'advisorName',
        sorter: (a: any, b: any) => (a.advisorName || '').localeCompare(b.advisorName || ''),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
/*       {
        title: 'Firm',
        dataIndex: 'firm',
        key: 'firm',
        sorter: (a: any, b: any) => (a.firm || '').localeCompare(b.firm || ''),
      },
 */      {
        title: 'Clients',
        dataIndex: 'clientCount',
        key: 'clientCount',
        sorter: (a: any, b: any) => (a.clientCount || 0) - (b.clientCount || 0),
      },
      {
        title: 'Total Assets',
        dataIndex: 'totalAssets',
        key: 'totalAssets',
				render: (totalAssets: string) => {
					const numericValue = parseFloat(totalAssets?.replace(/[$,]/g, '') || '0');
					return `$${numericValue.toLocaleString()}`;
				},
				sorter: (a: any, b: any) => {
					const aValue = parseFloat(a.totalAssets?.replace(/[$,]/g, '') || '0');
					const bValue = parseFloat(b.totalAssets?.replace(/[$,]/g, '') || '0');
					return aValue - bValue;
				},
      },
      {
        title: 'Action',
        key: 'action',
        render: (record: any) => (
          <Button 
            type="primary" 
            disabled={!record.clientCount || record.clientCount === 0}
            onClick={() => this.selectAdvisorFromModal(record)}
          >
            Select
          </Button>
        ),
      },
    ];


    return (
      <Table
        columns={columns}
        dataSource={filteredAdvisors.map((advisor, index) => ({
          ...advisor,
          key: advisor.advisorId || index
        }))}
        pagination={{ pageSize: 8 }}
        loading={this.state.loading}
        scroll={{ y: 400 }}
      />
    );
  };

sumFeesTotalOnYears = async (recId:any, productName:any) => {
	console.log('sumFeesTotalOnYears called with:', { recId, productName });
	
	// Get session token for authorization
	const sessionToken = sessionManager.getSessionToken();
	if (!sessionToken) {
		console.error('sumFeesTotalOnYears: No valid session token available');
		return;
	}
	
	const authHeaders = {
		headers: {
			Authorization: `Bearer ${sessionToken}`
		}
	};
	
	console.log('sumFeesTotalOnYears - session token:', sessionToken?.substring(0, 20) + '...');
	
	let totalFeesOnYear = this.state.subTotalFeesOnYears
	console.log('Processing years:', totalFeesOnYear.map(item => item.year));

	try {
		// Use Promise.all to wait for all HTTP requests to complete
		await Promise.all(totalFeesOnYear.map(async (item:any) => {
			let commQuery = '?partnerId='+recId+'&year=yearB'+(Number(moment().year())-Number(item.year)).toString()+'&productName='+productName
			console.log('Commission API call:', baseURL+"/commission"+commQuery);
			let commission = await axios.get(baseURL+"/commission"+commQuery, authHeaders)
			item.total = commission.data.total
		}))
		
		this.setState({subTotalFeesOnYears: totalFeesOnYear})
		this.copyYearsTotal(totalFeesOnYear)
		console.log('sumFeesTotalOnYears completed successfully');
	} catch (error: any) {
		console.error('Error in sumFeesTotalOnYears:', error);
		if (error.response?.status === 401) {
			console.error('Authorization failed - session may be expired');
		}
	}
}

copyYearsTotal = (totalArray:any) => {
    const  fiveYearsTotalArray:any = totalArray.filter((item:any) => item.year >= moment(this.state.selectedYear).subtract(4, "years").year() && item.year <= moment(this.state.selectedYear).year())
    const fiveYearsTotalValue= fiveYearsTotalArray.map((item:any) => item.total)
    this.setState({selectedYearCommTotal: fiveYearsTotalValue })
  }

	getAccountTrailerFeesTotal = async(recId:any, productName:any) => {
		console.log('getAccountTrailerFeesTotal called with:', { recId, productName });
		const commQuery = '?partnerId='+recId+'&productName='+productName
		
		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		if (!sessionToken) {
			console.error('getAccountTrailerFeesTotal: No valid session token available');
			return 0;
		}
		
		const authHeaders = {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		};
		
		console.log('getAccountTrailerFeesTotal - session token:', sessionToken?.substring(0, 20) + '...');
		console.log('TrailerFees API call:', baseURL+"/trailerfees"+commQuery, 'authHeader:', authHeaders);
		
		try {
			// Use Promise.all for consistency
			const [accountTrailerFees] = await Promise.all([
				axios.get(baseURL+"/trailerfees"+commQuery, authHeaders)
			]);
			
			if (accountTrailerFees.data.yearstotal===null) {
				return 0
			}
			else {
				return parseFloat(accountTrailerFees.data.yearstotal.replace(/[^0-9.-]+/g,""))  // money type convert to number
			}
		} catch (error: any) {
			console.error('Error in getAccountTrailerFeesTotal:', error);
			if (error.response?.status === 401) {
				console.error('Authorization failed for trailerfees endpoint - session may be expired');
			}
			// Return 0 on error to prevent the application from breaking
			return 0;
		}
	}

  	getTransactionData = async(transactionStartDate: string, transactionEndDate: string, recId: string, product: string) => {
		const transactionQuery = '?transactionStartDate='+transactionStartDate+'&transactionEndDate='+transactionEndDate+'&recId='+recId+'&productId='+product;
		
		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		const authHeaders = sessionToken ? {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		} : {};
		
		// Use Promise.all for consistency
		const [transaction_data] = await Promise.all([
			axios.get(baseURL+"/transactions"+transactionQuery, authHeaders)
		]);
		
		return transaction_data
	}

	getTotalPortfolioData = async(recId: string) => {
		const total_trans = await this.getTransactionData('', '', recId,'');
		if (!total_trans || total_trans.data.length === 0) {
			return {total_share_S1_balance:0, total_share_S2_balance:0, endingCapital:0, totalAccountTrailerFees:0, partnerInfo:recId};
		}
		const total_trans_data = total_trans.data;

		let total_share_S1_balance = 0;
		let total_share_S2_balance = 0;
		let endingCapital = 0;
		total_trans_data.forEach((tran:any)=>{
			if (tran.partnership.recId==='253a1dc7-3bdc-40d9-98c9-75ca619fb035') {
			total_share_S1_balance += Number(tran.shares);
			endingCapital +=  Number(tran.shares) * tran.partnership.fixedShareValue
			}
			if (tran.partnership.recId==='4097eb52-bcd6-4f56-b470-5b44e2bf6c54') {
				total_share_S2_balance += Number(tran.shares);
				endingCapital +=  Number(tran.shares) * tran.partnership.fixedShareValue
				}
		})
		const partnerInfo = this.state.partnersData.filter((partner:any)=>partner.recId === recId);
		const totalFees = await this.getAccountTrailerFeesTotal(recId, '')
		return {total_share_S1_balance, total_share_S2_balance, endingCapital, totalAccountTrailerFees: totalFees, partnerInfo:partnerInfo[0]};
	}

	getAccountPortfolio = async(recId: string) => {
		const partnerInfo = this.state.partnersData.filter((partner:any)=>partner.recId === recId);
		
		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		const authHeaders = sessionToken ? {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		} : {};
		
		// Use Promise.all to coordinate multiple async operations
		const [totalFees, portfolio] = await Promise.all([
			this.getAccountTrailerFeesTotal(recId, ''),
			axios.get(baseURL+'/partnerportfolio?recId='+recId, authHeaders)
		]);
		
		return {total_share_S1_balance:portfolio.data.partner.shareS1, total_share_S2_balance:portfolio.data.partner.shareS2, accountTotal:parseFloat(portfolio.data.partner.totalValue.replace(/[^0-9.-]+/g,"")), totalAccountTrailerFees: totalFees, partnerInfo:partnerInfo[0]}	
	}
	countTotalAccountsTrailerFees = async(recIds:string[]) => {
		const totalAccountTrailerFeesArray = await Promise.all(recIds.map(async (recId:string) => {
			return await this.getAccountTrailerFeesTotal(recId, '')
		}));
		let allAccountsTrailerFees = 0;
		totalAccountTrailerFeesArray.forEach((value)=>{
			allAccountsTrailerFees += value
		})
		this.setState({totalAccountsTrailerFees: allAccountsTrailerFees})
	}

	countTotalAccountsValue = async(recIds:string[]) => {
		const totalAccountValueArray = await Promise.all(recIds.map(async (recId:string) => {
			return await this.getAccountPortfolio(recId)
		}));
		let totalAccountsValue = 0;
		 let allAccountsTrailerFees = 0
		totalAccountValueArray.forEach((value)=>{


			allAccountsTrailerFees += value.totalAccountTrailerFees  
			if(value.accountTotal){
				totalAccountsValue += value.accountTotal;
			}
		})
    this.setState({totalAccountsValue: parseFloat(totalAccountsValue.toFixed(2)), totalAccountsTrailerFees: parseFloat(allAccountsTrailerFees.toFixed(2))});
		this.setState({totalAccountValue: totalAccountValueArray})
	}

	rangeConfig = {
		rules: [{ type: 'array' as const, required: true, message: 'Please select time!' }],
	};

	onFinishTransaction = async (fieldsValue: any) => {
		const rangeValue = fieldsValue['range-picker'];
		const values = {
		  ...fieldsValue,
		  'range-picker': [rangeValue[0].format('MM-DD-YYYY'), rangeValue[1].format('MM-DD-YYYY')],
		};
		this.setState({ transactionStartDate: values['range-picker'][0], transactionEndDate: values['range-picker'][1] });

		// Use Promise.all to wait for async operations
		const [transaction_data] = await Promise.all([
			this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, this.state.currentAccountRecId, this.state.transactionProductId)
		]);
		
		this.setState({ transactionData: transaction_data.data});
	};

	onClickTransactionYear = async (e:any) => {
		switch (e.target.value) {
			case 'currentYear':
				this.setState({ transactionStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'), transactionEndDate: moment().format('MM-DD-YYYY') });
				break;
			case 'latestTwoYears':
				this.setState({ transactionStartDate: moment().dayOfYear(1).subtract(1, 'years').format('MM-DD-YYYY'), transactionEndDate: moment().format('MM-DD-YYYY') });
				break;
			case 'allYears':
				this.setState({ transactionStartDate:  moment().dayOfYear(1).subtract(9, 'years').format('MM-DD-YYYY'), transactionEndDate:  moment().format('MM-DD-YYYY') });
				break;			
			case 'GINKGO-S1':
				this.setState({ transactionProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035' });
				break;
			case 'GINKGO-S2':
				this.setState({ transactionProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' });
				break;
			case 'All':
				this.setState({ transactionProductId: '' });
				break;
					}
		await this.delay(500)
		// Use Promise.all to wait for all async operations to complete
		const [transaction_data] = await Promise.all([
			this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, this.state.currentAccountRecId, this.state.transactionProductId)
		]);
		this.setState({ transactionData: transaction_data.data});
	//	this.render();
	};

	onFinishCert = async (fieldsValue: any) => {
		const rangeValue = fieldsValue['range-picker'];
		const values = {
		  ...fieldsValue,
		  'range-picker': [rangeValue[0].format('MM-DD-YYYY'), rangeValue[1].format('MM-DD-YYYY')],
		};
		
		// Extract the new date values
		const newCertStartDate = values['range-picker'][0];
		const newCertEndDate = values['range-picker'][1];
		
		this.setState({ certStartDate: newCertStartDate, certEndDate: newCertEndDate });

		// Use the new date values directly instead of this.state (which is async)
		const [cert_data] = await Promise.all([
			this.getCertData(newCertStartDate, newCertEndDate, this.state.currentAccountRecId, this.state.certificateProductId)
		]);
		
		this.setState({ certData: cert_data.data});
	};

	onClickCommYear = async (e:any) => {
		switch (e.target.value) {
			case 'firstYear':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(13, 'years').format('MM-DD-YYYY'), certEndDate: moment().dayOfYear(365).subtract(5, 'years').format('MM-DD-YYYY'), selectedYear: moment().dayOfYear(1).subtract(4, 'years').format(dateFormat) });
				break;
			case 'secondYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(12, 'years').format('MM-DD-YYYY'), certEndDate: moment().dayOfYear(365).subtract(4, 'years').format('MM-DD-YYYY'), selectedYear: moment().dayOfYear(1).subtract(3, 'years').format(dateFormat) });
				break;
			case 'thirdYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(11, 'years').format('MM-DD-YYYY'), certEndDate: moment().dayOfYear(365).subtract(3, 'years').format('MM-DD-YYYY'), selectedYear: moment().dayOfYear(1).subtract(2, 'years').format(dateFormat) });
				break;
			case 'fourthYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(10, 'years').format('MM-DD-YYYY'), certEndDate: moment().dayOfYear(365).subtract(2, 'years').format('MM-DD-YYYY'), selectedYear: moment().dayOfYear(1).subtract(1, 'years').format(dateFormat) });
				break;
			case 'fifthYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(9, 'years').format('MM-DD-YYYY'), certEndDate: moment().subtract(1, 'years').format('MM-DD-YYYY'), selectedYear: moment().dayOfYear(1).format(dateFormat) });
//				this.setState({ certStartDate: moment('01-01-2012').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
				break;			
			case 'GINKGO-S1':
				this.setState({ certificateProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035', certificateProductName: 'GINKGO-S1' });
				break;
			case 'GINKGO-S2':
				this.setState({ certificateProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54', certificateProductName: 'GINKGO-S2'});
				break;
			case 'All':
				this.setState({ certificateProductId: '', certificateProductName: ''});
				break;
	}
/* 		const cert_data = await this.getCertData(this.state.certStartDate, this.state.certEndDate, this.state.currentAccountRecId, this.state.certificateProductId);
		this.setState({ certData: cert_data.data});
 */		await this.getCommissionData(this.state.currentAccountRecId, this.state.certificateProductName);
		await this.sumFeesTotalOnYears(this.state.currentAccountRecId, this.state.certificateProductName)
		await this.delay(500)
	//	this.render();
		
	};
	
	delay = async (milliseconds:any) => {
		return new Promise(resolve => {
		setTimeout(resolve, milliseconds);
		});
	}

	onClickCertYear = async (e:any) => {
		switch (e.target.value) {
			case 'currentYear':
				this.setState({ certStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
				break;
			case 'latestTwoYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(1, 'years').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
				break;
			case 'allYears':
				this.setState({ certStartDate: moment().dayOfYear(1).subtract(9, 'years').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
				break;			
			case 'GINKGO-S1':
				this.setState({ certificateProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035' });
				break;
			case 'GINKGO-S2':
				this.setState({ certificateProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' });
				break;
			case 'All':
				this.setState({ certificateProductId: '' });
				break;
	}
		await this.delay(500)
		
		// Use Promise.all to wait for async operations
		const [cert_data] = await Promise.all([
			this.getCertData(this.state.certStartDate, this.state.certEndDate, this.state.currentAccountRecId, this.state.certificateProductId)
		]);
		
		this.setState({ certData: cert_data.data});
	};
	
	getCertData = async(certStartDate: string, certEndDate: string, recId:string, product: string) => {
		const certQuery = '?certStartDate='+certStartDate+'&certEndDate='+certEndDate+'&recId='+recId+'&productId='+product;;
		
		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		const authHeaders = sessionToken ? {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		} : {};
		
		// Use Promise.all for consistency and future extensibility
		const [cert_data] = await Promise.all([
			axios.get(baseURL+"/certificates"+certQuery, authHeaders)
		]);
		
		let certSubtotal = 0
		if (cert_data.data.length!==0) {
			cert_data.data.forEach((cert:any)=> {
			certSubtotal += Number(cert.transaction[0].shares)
		})}
			this.setState({certSub_total: Number(certSubtotal.toFixed(2))})
		return cert_data
	}

	getRedeemData = async(recId: string) => {	
		// Get session token for authorization
		const sessionToken = sessionManager.getSessionToken();
		const authHeaders = sessionToken ? {
			headers: {
				Authorization: `Bearer ${sessionToken}`
			}
		} : {};
		
		// Use Promise.all for consistency
		const [redeem_data] = await Promise.all([
			axios.get(baseURL+"/redeemrecord/?recId="+recId, authHeaders)
		]);
		
		return redeem_data
	}



	handleTagChange = async (e: any) => {
		
		let currentAccountRecId = e.target.id;
		this.setState( (prevState:any)=> ({ ...prevState, currentAccountRecId }));
		const currentPartnerInfo = this.state.partnersData.filter((partner:any)=>partner.recId === currentAccountRecId);
		
		// Use Promise.all to coordinate multiple async operations
		const [transaction_data, redeem_data, cert_data] = await Promise.all([
			this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, currentAccountRecId, this.state.transactionProductId),
			this.getRedeemData(currentAccountRecId),
			this.getCertData(this.state.certStartDate, this.state.certEndDate, currentAccountRecId, this.state.certificateProductId)
		]);
		
		this.setState({ transactionData: transaction_data.data, certData: cert_data.data, redeemData: redeem_data.data, displayAccountNum: currentPartnerInfo[0].account});
		await this.getCommissionData(currentAccountRecId, this.state.certificateProductName)
		this.setState({ displayAccountNum: currentPartnerInfo[0].account, displayAdvisorType: currentPartnerInfo[0].advisorType, partner: currentPartnerInfo[0] });
		await this.decodeSIN(currentPartnerInfo[0].tin);
		await this.sumFeesTotalOnYears(currentAccountRecId, this.state.certificateProductName)
	};

	getCommissionData = async(partnerId:any, productName:any) => {
		const commQuery = '?partnerId='+partnerId+'&productName='+productName
		
		// Use Promise.all for consistency
		const [comm_data] = await Promise.all([
			axios.get(baseURL+"/commissiondetails"+commQuery)
		]);
		
		this.setState({ commData: comm_data.data});
	}

	decodeSIN = async(encryptedSin: string) => {
		if (!encryptedSin || encryptedSin === '000000000' || encryptedSin === '') {
			this.setState({ decodedSin: '' });
			return;
		}

		try {
			// Get session token for authorization
			const sessionToken = sessionManager.getSessionToken();
			const authHeaders = sessionToken ? {
				headers: {
					Authorization: `Bearer ${sessionToken}`
				}
			} : {};

			const response = await axios.get(`${baseURL}/decodeSIN?sin=${encryptedSin}`, authHeaders);
			this.setState({ decodedSin: response.data || '' });
		} catch (error) {
			console.error('Error decoding SIN:', error);
			this.setState({ decodedSin: '' });
		}
	}

	showModal = () => {
		this.setState({
		  isModalOpen: true,
		});
	};
	
	handleOk = async () => {
		console.log('selected partner sin:', this.state.selectedPartnerSin);

		// Use Promise.all for initial data loading
		const [partners] = await Promise.all([
			axios.get(baseURL+"/advisoraccounts?advisorId=" + this.state.advisorId + '&partnerSin=' + this.state.selectedPartnerSin)
		]);
		
		this.setState({
			isModalOpen: false,
		});
console.log('return partners:', partners.data);
		this.setState({selectedYear: moment().dayOfYear(1).format(dateFormat)})
		await this.getAccountTrailerFeesTotal(partners.data[0].recId, '')
		await this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
		
		this.setState({partner: partners.data[0], partnersData: partners.data, currentAccountRecId: partners.data[0].recId, displayAccountNum: partners.data[0].account, displayAdvisorType: partners.data[0].advisorType })
		
		// Decode the SIN for display
		await this.decodeSIN(partners.data[0].tin);
		
		// Use Promise.all for data fetching
		const [cert_data, comm_data] = await Promise.all([
			this.getCertData(this.state.certStartDate, this.state.certEndDate, partners.data[0].recId, this.state.certificateProductId),
			axios.get(baseURL+"/commissiondetails?partnerId="+partners.data[0].recId+'&productName='+'')
		]);
		
		this.setState({ certData: cert_data.data, commData: comm_data.data});
		await this.countTotalAccountsValue(partners.data.map((partnerData:any)=>(partnerData.recId)))
	}

	handleCancel =() => {
		this.setState({
		  isModalOpen: false,
		});
	};

	handleSearch = (value) => {
		this.setState({ searchText: value });
		this.render();
	  };

	  renderTable = () => {
		const columns = [
			{
				title: 'First Name',
				dataIndex: 'firstName',
				key: 'firstName',
				sorter: (a: any, b: any) => (a.firstName || '').localeCompare(b.firstName || ''),
			},
			{
				title: 'Last Name',
				dataIndex: 'lastName',
				key: 'lastName',
				sorter: (a: any, b: any) => (a.lastName || '').localeCompare(b.lastName || ''),
			},
 			{
			  title: 'Phone',
			  dataIndex: 'phone',
			},
 			{
				title: 'Email',
				dataIndex: 'emailAddress',
			},
			{
				title: 'Total Drip',
				dataIndex: 'totalDrip',
				key: 'totalDrip',
				render: (totalDrip: string) => {
					const numericValue = parseFloat(totalDrip?.replace(/[$,]/g, '') || '0');
					return `$${numericValue.toLocaleString()}`;
				},
				sorter: (a: any, b: any) => {
					const aValue = parseFloat(a.totalDrip?.replace(/[$,]/g, '') || '0');
					const bValue = parseFloat(b.totalDrip?.replace(/[$,]/g, '') || '0');
					return aValue - bValue;
				},
			},
			{
				title: 'Total Value',
				dataIndex: 'totalValue',
				key: 'totalValue',
				render: (totalValue: string) => {
					const numericValue = parseFloat(totalValue?.replace(/[$,]/g, '') || '0');
					return `$${numericValue.toLocaleString()}`;
				},
				sorter: (a: any, b: any) => {
					const aValue = parseFloat(a.totalValue?.replace(/[$,]/g, '') || '0');
					const bValue = parseFloat(b.totalValue?.replace(/[$,]/g, '') || '0');
					return aValue - bValue;
				},
			},
		  ];
		  const rowSelection = {
			onChange: (selectedRowKey: any, selectedRow: any) => {
			this.setState({selectedPartnerSin: selectedRow[0].tin});
			}
			};
			
		  const data = this.state.clientList
		  const filteredData = data.filter((item) =>
			// replace 'name' with the property you want to search by
			item.lastName.toLowerCase().includes(this.state.searchText.toLowerCase()) ||
			item.firstName.toLowerCase().includes(this.state.searchText.toLowerCase()) 
		  );
		  return <Table 
		  columns={columns} 
		  dataSource={filteredData} 
		  size="small" 
		  rowSelection={{type: "radio",...rowSelection}} />;
		};

/* 	 handleYearMonthSelect = async (year: string, month: string) => {
		this.setState({selectedCommYear: year, selectedCommMonth: month})
		
		// Determine which email to use based on user type
		let emailToUse = this.state.isAuthenticated[1]; // Default to regular advisor email
		
		if (this.state.isEMDUser && this.state.selectedAdvisorId) {
			// For EMD users, use the selected advisor's email
			const selectedAdvisor = this.state.emdAdvisors.find((advisor: any) => advisor.advisorId === this.state.selectedAdvisorId);
			if (selectedAdvisor && selectedAdvisor.email) {
				emailToUse = selectedAdvisor.email;
			}
		}
		
		// Use Promise.all to coordinate multiple async operations
		const [advisorCommData, totalValue] = await Promise.all([
			axios.get(baseURL+'/advisorcommission?email=' + emailToUse + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear),
			axios.get(baseURL+'/advisorcommissiontotalbymonth?email=' + emailToUse + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear)
		]);
		
		this.setState({ commDataAdvisor: advisorCommData.data, currentMonthFeesTotal: totalValue.data})
	  };

 */

  renderSummaryTab = () => {
    const { emdSummary, advisors } = this.state;

    const advisorColumns = [
      {
        title: 'Advisor Name',
        dataIndex: 'advisorName',
        key: 'advisorName',
        sorter: (a: any, b: any) => (a.advisorName || '').localeCompare(b.advisorName || ''),
      },
      {
        title: 'Firm',
        dataIndex: 'firm',
        key: 'firm',
        sorter: (a: any, b: any) => (a.firm || '').localeCompare(b.firm || ''),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Client Count',
        dataIndex: 'clientCount',
        key: 'clientCount',
        sorter: (a: any, b: any) => (a.clientCount || 0) - (b.clientCount || 0),
      },
      {
        title: 'Total Assets',
        dataIndex: 'totalAssets',
        key: 'totalAssets',
        render: (value: string) => `$${parseFloat(value || '0').toLocaleString()}`,
        sorter: (a: any, b: any) => parseFloat(a.totalAssets || '0') - parseFloat(b.totalAssets || '0'),
      },
      {
        title: 'Action',
        key: 'action',
        render: (record: any) => (
          <Button 
            type="primary" 
            onClick={() => {
              this.handleAdvisorSelect(record.advisorId);
              this.setState({ activeTab: 'details' });
            }}
          >
            View Details
          </Button>
        ),
      },
    ];

    return (
      <div>
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={6}>
            <Card>
              <Statistic
                title="Total Advisors"
                value={emdSummary.totalAdvisors}
                prefix={<BankOutlined />}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Total Clients"
                value={emdSummary.totalClients}
                prefix={<TeamOutlined />}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Total Assets"
                value={parseFloat(emdSummary.totalAssets?.replace(/[$,]/g, '') || '0')}
                prefix={<DollarCircleOutlined />}
                formatter={(value) => `$${value?.toLocaleString()}`}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Avg Assets/Advisor"
                value={emdSummary.totalAdvisors > 0 ? parseFloat(emdSummary.totalAssets?.replace(/[$,]/g, '') || '0') / emdSummary.totalAdvisors : 0}
                prefix={<TrophyOutlined />}
                formatter={(value) => `$${value?.toLocaleString()}`}
              />
            </Card>
          </Col>
        </Row>

        <Card title="Advisor Summary" style={{ marginTop: 16 }}>
          <Table
            columns={advisorColumns}
            dataSource={advisors.map((advisor, index) => ({
              ...advisor,
              key: advisor.advisorId || index
            }))}
            pagination={{ pageSize: 10 }}
            loading={this.state.loading}
          />
        </Card>
      </div>
    );
  };

  renderDetailsTab = () => {
    const { selectedAdvisorId, advisors, advisorClients, advisorAssets } = this.state;
    
    const selectedAdvisor = advisors.find(advisor => advisor.recId === selectedAdvisorId);

    const clientColumns = [
      {
        title: 'Client Name',
        key: 'name',
        render: (record: any) => `${record.firstName} ${record.lastName}`,
        sorter: (a: any, b: any) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`),
      },
      {
        title: 'Email',
        dataIndex: 'emailAddress',
        key: 'emailAddress',
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: 'Total Value',
        dataIndex: 'totalValue',
        key: 'totalValue',
        render: (value: string) => value || '$0.00',
        sorter: (a: any, b: any) => {
          const aVal = parseFloat((a.totalValue || '0').replace(/[$,]/g, ''));
          const bVal = parseFloat((b.totalValue || '0').replace(/[$,]/g, ''));
          return aVal - bVal;
        },
      },
      {
        title: 'Total Drip',
        dataIndex: 'totalDrip',
        key: 'totalDrip',
        render: (value: string) => value || '$0.00',
      },
    ];

    const assetColumns = [
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: 'Client Name',
        dataIndex: 'clientName',
        key: 'clientName',
        sorter: (a: any, b: any) => a.clientName.localeCompare(b.clientName),
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        sorter: (a: any, b: any) => a.category.localeCompare(b.category),
      },
      {
        title: 'Total Value',
        dataIndex: 'totalValue',
        key: 'totalValue',
        render: (value: string) => value || '$0.00',
        sorter: (a: any, b: any) => {
          const aVal = parseFloat((a.totalValue || '0').replace(/[$,]/g, ''));
          const bVal = parseFloat((b.totalValue || '0').replace(/[$,]/g, ''));
          return aVal - bVal;
        },
      },
    ];

    return (
      <div>
        <Row style={{ marginBottom: 16 }}>
          <Col span={24}>
            <Select
              placeholder="Select an advisor to view details"
              style={{ width: 400 }}
              value={selectedAdvisorId}
              onChange={this.handleAdvisorSelectChange}
              loading={this.state.loading}
            >
              {advisors.map(advisor => (
                <Option key={advisor.recId} value={advisor.recId}>
                  {advisor.firstName} {advisor.lastName} - {advisor.firm}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {selectedAdvisor && (
          <>
            <Card title="Advisor Information" style={{ marginBottom: 16 }}>
              <Descriptions column={2}>
                <Descriptions.Item label="Name">
                  {selectedAdvisor.firstName} {selectedAdvisor.lastName}
                </Descriptions.Item>
                <Descriptions.Item label="Firm">
                  {selectedAdvisor.firm}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                  {selectedAdvisor.email}
                </Descriptions.Item>
                <Descriptions.Item label="Phone">
                  {selectedAdvisor.phone}
                </Descriptions.Item>
              </Descriptions>
            </Card>

            <Tabs defaultActiveKey="clients">
              <TabPane tab="Client List" key="clients">
                <Table
                  columns={clientColumns}
                  dataSource={advisorClients.map((client, index) => ({
                    ...client,
                    key: index
                  }))}
                  pagination={{ pageSize: 10 }}
                  loading={this.state.loading}
                />
              </TabPane>
              
              <TabPane tab="Asset Breakdown" key="assets">
                <Table
                  columns={assetColumns}
                  dataSource={advisorAssets.map((asset, index) => ({
                    ...asset,
                    key: index
                  }))}
                  pagination={{ pageSize: 10 }}
                  loading={this.state.loading}
                />
              </TabPane>
            </Tabs>
          </>
        )}
      </div>
    );
  };

  render() {
    const { emdSummary, selectedAdvisor, loading, emdInfo } = this.state;

    return (
      <div style={{ padding: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <Title level={2}>Ginkgo EMD Dashboard</Title>
          {emdInfo && (
            <div style={{ marginTop: '8px' }}>
              <Title level={4} style={{ color: '#1890ff', margin: 0 }}>
                {emdInfo.firm}
              </Title>
              <p style={{ color: '#666', margin: '4px 0' }}>
                {emdInfo.contactFirstname} {emdInfo.contactLastname} • {emdInfo.contactEmail}
              </p>
            </div>
          )}
        </div>

        {/* Early Access Program */}
        <RedemptionPoolChart
          month={this.state.redemptionMonth}
          year={this.state.redemptionYear}
          drip={this.state.dripTotal}
          newPurchase={this.state.newPurchaseTotal}
          totalRedemption={this.getTotalRedemption()}
          totalMatch={this.state.totalMatch}
          totalNonMatch={this.state.totalNonMatch}
          totalRetracted={this.state.totalRetracted}
          matchPeriodAllocated={this.state.matchPeriodAllocated}
          onPeriodChange={this.handleRedemptionPeriodChange}
          redemptionByFirm={this.getRedemptionByFirm()}
        />

        {/* Redemption Requests (read-only for EMD) */}
        <Card
          title={(
            <span style={{ whiteSpace: 'pre' }}>
              {buildListHeader('Retraction List', this.state.redemptionRecords)}
            </span>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionRequestTable
            records={this.getFilteredRedemptionRows()}
            loading={this.state.redemptionLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
          />
        </Card>

        {/* Redemption Bookings (read-only for EMD) */}
        <Card
          title={(
            <span style={{ whiteSpace: 'pre' }}>
              {buildListHeader('Retraction Booking List', this.state.bookingRecords)}
            </span>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionBookingTable
            records={this.state.bookingRecords}
            loading={this.state.bookingLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
          />
        </Card>

        {/* Prominent Totals Display */}
        <Card style={{ marginBottom: '18px', backgroundColor: '#f0f8ff' }}>
          <Row gutter={24} justify="center">
            <Col span={8}>
              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#1890ff', marginBottom: '5px' }}>
                  Total Advisors
                </Title>
                <Title level={1} style={{ color: '#1890ff', margin: 0 }}>
                  {emdSummary.totalAdvisors}
                </Title>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                  Total Clients
                </Title>
                <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                  {emdSummary.totalClients}
                </Title>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                  Total Assets
                </Title>
                <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                  ${parseFloat(emdSummary.totalAssets?.replace(/[$,]/g, '') || '0').toLocaleString()}
                </Title>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Action Buttons */}
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <Space size="middle">
            <Button 
              type="primary" 
              size="large"
              onClick={this.showAdvisorListModal}
              style={{ minWidth: '150px' }}
            >
              Advisor List
            </Button>
            <Button 
              type="primary" 
              size="large"
              onClick={this.showRedemptionReportModal}
              style={{ minWidth: '150px' }}
            >
              Redemption Report
            </Button>
{/*             <Button 
              type="primary" 
              size="large"
              onClick={this.showCommissionReportModal}
              style={{ minWidth: '150px' }}
            >
              Commission Report
            </Button>
 */}          </Space>
        </div>

        {/* Selected Advisor Information */}
        {selectedAdvisor && (
          <Card title="Selected Advisor Information" style={{ marginBottom: '18px' }}>
            <Descriptions column={2} bordered>
              <Descriptions.Item label="Name">{selectedAdvisor.advisorName}</Descriptions.Item>
              <Descriptions.Item label="Email">{selectedAdvisor.email}</Descriptions.Item>
              <Descriptions.Item label="Firm">{selectedAdvisor.firm}</Descriptions.Item>
              <Descriptions.Item label="Total Clients">{selectedAdvisor.clientCount}</Descriptions.Item>
              <Descriptions.Item label="Total Assets" span={2}>{selectedAdvisor.totalAssets}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}

        {/* Detailed Advisor Portfolio Sections */}
        {selectedAdvisor && (
          <div>
            {/* Action Buttons for Detailed Views */}
            <div style={{ textAlign: 'center', marginBottom: '18px' }}>
              <Space size="middle">
                <Button 
                  type="primary" 
                  size="large"
                  onClick={this.showModal}
                  style={{ minWidth: '150px' }}
                >
                  Client List
                </Button>
              </Space>
            </div>

            {/* Selected Client Information */}
            {selectedAdvisor && (
              <Card title="Selected Client Information" style={{ marginBottom: '18px' }}>
                <Descriptions column={2} bordered>
                  <Descriptions.Item label="Email">{this.state.partner.emailAddress || ''} </Descriptions.Item>
                  <Descriptions.Item label="First Name">{this.state.partner.firstName || ''}</Descriptions.Item>
                  <Descriptions.Item label="Last Name">{this.state.partner.lastName || ''}</Descriptions.Item>
                  <Descriptions.Item label="Full Name">{this.state.partner.fullName || ''}</Descriptions.Item>
                  <Descriptions.Item label="Phone">{this.state.partner.phoneHome || ''}</Descriptions.Item>
                  <Descriptions.Item label="SIN">{this.state.decodedSin || ''}</Descriptions.Item>
                  <Descriptions.Item label="Address" span={2}>
                    {[
                      this.state.partner.street,
                      this.state.partner.city,
                      this.state.partner.province,
                      this.state.partner.postCode
                    ].filter(Boolean).join(', ') || ''}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            )}

            <Title level={4} style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'center' }}>Client  Portfolio</Title>
            <div className="ant-table " style={{ display: 'flex', flex: 'auto', marginBottom: '18px' }}>
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Account</th>
                    <th>Shares(S1) Balance</th>
                    <th>Shares(S2) Balance</th>
                    <th>Account Value</th> 
                    <th>Commission/Trailer Fees(From {moment().subtract(9, "years").year()})</th> 
                  </tr>
                </thead>  
                <tbody className="ant-table-tbody">
                  {
                    this.state.totalAccountValue.map((value:any, i:number)=>(
                      <tr key={i}>
                        <td><a onClick={this.handleTagChange} id={value.partnerInfo.recId}>{value.partnerInfo.category} ({value.partnerInfo.account})</a></td>
                        <td>{Number(value.total_share_S1_balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                        <td>{Number(value.total_share_S2_balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                        <td>${Number(value.accountTotal).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                        <td><strong>${value.totalAccountTrailerFees}</strong></td>
                      </tr>
                    ))
                  }
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><strong>Total Value: ${Number(this.state.totalAccountsValue || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</strong></td>
                    <td><strong>Total Fees: ${Number(this.state.totalAccountsTrailerFees || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</strong></td>
                  </tr>           	                    
                </tbody> 
              </table>
            </div> 



            {/* Certificate Section */}
            <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
              <Panel header={`Certificates (Account:${this.state.displayAccountNum}) `} style={{ fontSize: "20px" }} key="1">
                <div style={{marginTop: '40px'}}>
                  <Form name="time_related_controls" onFinish={this.onFinishCert} layout="inline"
                    initialValues={{'range-picker': [dayjs().startOf('year'), dayjs()]}}>
                    {/*<Form.Item name="date-picker" label="DatePicker" {...this.config}>
                      <DatePicker />
                    </Form.Item>*/}
                    <Form.Item name="range-picker"  {...this.rangeConfig}>
                      <RangePicker format={dateFormat}/>
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                    <Form.Item  name="year-select" >
                      <Radio.Group onChange={this.onClickCertYear}>
                        <Radio.Button value="currentYear">This Year</Radio.Button> 
                        <Radio.Button value="latestTwoYears">Last Two Years</Radio.Button>
                        <Radio.Button value="allYears">All Years</Radio.Button>
                      </Radio.Group>
                    </Form.Item>					
                    <Form.Item  name="product-select" >
                      <Radio.Group onChange={this.onClickCertYear}>
                        <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                        <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                        <Radio.Button value="All">All</Radio.Button>
                      </Radio.Group>
                    </Form.Item>					
                  </Form>
                </div>
                <div className="ant-table">
                  <table>
                    <thead className="ant-table-thead">
                      <tr>
                        <th>Certificate #</th>
                        <th>Product</th>
                        <th>Shares</th>
                        <th>Price</th>
                        <th>Amount Paid</th>
                        <th>Date Issued</th>               
                        <th>Maturity Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>  
                    <tbody className="ant-table-tbody">
                      {
                        this.state.certData.map((cert:any, i:any)=>(      
                          <tr className="ant-table-row" key={i}>
                            <td>{cert.number}</td>
                            <td>{cert.partnership?cert.partnership.account:''}</td>
                            <td>{cert.transaction.length>0?Number(cert.transaction[0].shares).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"):''}</td>
                            <td>{cert.transaction.length>0?cert.transaction[0].sharePrice:''}</td>
                            <td>{cert.transaction.length>0?cert.transaction[0].amount:''}</td>
                            <td>{cert.issuedDate?moment(cert.issuedDate, DB_dateFormat).format(dateFormat):''}</td>
                            <td>{cert.maturity? moment(cert.maturity, DB_dateFormat).format(dateFormat) : ''}</td>
                            <td>{
                              (
                                ()=>{
                                  if (cert.status === 0) {return 'active'}
                                  else if (cert.status === 1) {return 'redeemed'}
                                  else if (cert.status === 2) {return 'transferred'}
                                }
                              ) ()
                            }</td>
                          </tr>  
                        ))
                      }
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>Total: ${Number(this.state.certSub_total * 10).toFixed(2)}</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>           	                    
                    </tbody>
                  </table>
                </div> 
              </Panel>
            </Collapse>			

            {/* Transaction History Section */}
            <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
              <Panel header={`Transaction History (Account:${this.state.displayAccountNum})`} style={{ fontSize: "20px" }} key="2">
                <div style={{marginTop: '40px'}}>
                  <Form name="time_related_controls" onFinish={this.onFinishTransaction} layout="inline" 
                    initialValues={{'range-picker': [dayjs().startOf('year'), dayjs()]}}>
                    <Form.Item name="range-picker"  {...this.rangeConfig}>
                      <RangePicker format={dateFormat}/>
                    </Form.Item>
       
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                    <Form.Item  name="year-select" >
                      <Radio.Group onChange={this.onClickTransactionYear}>
                        <Radio.Button value="currentYear">This Year</Radio.Button>
                        <Radio.Button value="latestTwoYears">Last Two Years</Radio.Button>
                        <Radio.Button value="allYears">All Years</Radio.Button>
                      </Radio.Group>
                    </Form.Item>					
                    <Form.Item  name="product-select" >
                      <Radio.Group onChange={this.onClickTransactionYear}>
                        <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                        <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                        <Radio.Button value="All">All</Radio.Button>
                      </Radio.Group>
                    </Form.Item>					
                  </Form>
                </div>
                
                <div className="ant-table">
                  <table>
                    <thead className="ant-table-thead">
                      <tr>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Description</th>
                        <th>Shares</th>
                        <th>Amount</th>               
                        <th>Fee</th>
                        <th>Withholding</th>
                        <th>Certificate #</th>
                      </tr>
                    </thead>  
                    <tbody className="ant-table-tbody">
                      {
                        this.state.transactionData.map((trans:any, i:any)=>(                                               
                          <tr className="ant-table-row" key={i}>
                            <td>{moment(trans.recDate, DB_dateFormat).format(dateFormat)}</td>
                            <td>{trans.partnership? trans.partnership.account : ''}</td>
                            <td>{trans.memo}</td>
                            <td>{Number(trans.shares).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>					
                            <td>{trans.amount}</td>
                            <td>{trans.penalty}</td>
                            <td>{trans.holdBack}</td>
                            <td>{trans.certificate? trans.certificate.number : ''}</td>					
                          </tr>   
                        ))
                      }
                    </tbody>
                  </table>
                </div> 
              </Panel>
            </Collapse>

            {/* Redemption History Section */}
            <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
              <Panel header={`Redemption History (Account:${this.state.displayAccountNum})`} style={{ fontSize: "20px" }} key="3">
                <div className="ant-table">
                  <table>
                    <thead className="ant-table-thead">
                      <tr>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Amount</th>               
                      </tr>
                    </thead>  
                    <tbody className="ant-table-tbody">
                      {this.state.redeemData ? (
                        this.state.redeemData.map((redeem:any, i:any)=>(                                               
                          <tr className="ant-table-row" key={i}>
                            <td>{moment(redeem.redeemDate, DB_dateFormat).format(dateFormat)}</td>
                            <td>{redeem.productId === '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' ? 'S2' : 
                            redeem.productId === '253a1dc7-3bdc-40d9-98c9-75ca619fb035' ? 'S1' : 
                            redeem.productId === '0229bdc8-0f0f-4650-9a90-2ebda890c648' ? 'Bond B' : 'Bond A'}</td>
                            <td>{redeem.redeemValue}</td>
                          </tr>   
                        ))
                      ) : (
                        <tr className="ant-table-row">
                          <td colSpan={3}>No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div> 
              </Panel>
            </Collapse>

          </div>
        )}

        {/* Advisor List Modal */}
        <Modal 
          title={<div style={{textAlign: 'center', fontSize: "23px", fontWeight: 'bold'}}>Select Advisor</div>}  
          open={this.state.isAdvisorListModalOpen} 
          onCancel={this.handleAdvisorListCancel} 
          width={1000}
          footer={[
            <Button key="cancel" onClick={this.handleAdvisorListCancel}>
              Cancel
            </Button>
          ]}
        >
          <Input.Search 
            placeholder="Search by advisor name, email, or firm" 
            onChange={(e) => this.handleAdvisorSearch(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          {this.renderAdvisorListTable()}
        </Modal>

        {/* Client List Modal - Use existing modal */}
        <Modal title={<div style={{textAlign: 'center', fontSize: "23px", fontWeight: 'bold'}}>
          Client List
          {this.state.selectedAdvisor && this.state.selectedAdvisor.advisorName && (
            <div style={{ fontSize: '16px', fontWeight: 'normal', color: '#666', marginTop: '8px' }}>
              Advisor: {this.state.selectedAdvisor.advisorName}
            </div>
          )}
        </div>}  
          open={this.state.isModalOpen} 
          onOk={this.handleOk} 
          onCancel={this.handleCancel} 
          width={1000}
        >
          <Input.Search placeholder="Name Search" onSearch={this.handleSearch} style={{ marginBottom: 16 }}/>
          {this.renderTable()}
        </Modal>

        {/* Redemption Report Modal */}
        <Modal 
          title={<div style={{textAlign: 'center', fontSize: "23px", fontWeight: 'bold'}}>Generate Redemption Report</div>}
          open={this.state.isRedemptionReportModalOpen}
          onCancel={this.handleRedemptionReportCancel}
          width={500}
          footer={[
            <Button key="cancel" onClick={this.handleRedemptionReportCancel}>
              Cancel
            </Button>,
            <Button 
              key="generate" 
              type="primary" 
              loading={this.state.loading}
              onClick={this.generateRedemptionReport}
            >
              Generate Report
            </Button>
          ]}
        >
          <div style={{ padding: '16px 0' }}>
            <Title level={5}>Select Month for Redemption Report:</Title>
            <Select
              style={{ width: '100%' }}
              value={this.state.selectedReportMonth}
              onChange={(value) => this.setState({ selectedReportMonth: value })}
              placeholder="Select month"
            >
              {Array.from({ length: 15 }, (_, i) => {
                const date = moment().subtract(i + 1, 'months');
                const value = date.format('YYYY-MM');
                const label = date.format('MMMM YYYY');
                return (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                );
              })}
            </Select>
            {this.state.emdInfo && (
              <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
                Report will be generated for: <strong>{this.state.emdInfo.firm}</strong>
              </p>
            )}
          </div>
        </Modal>

        {/* Commission Report Modal */}
        <Modal 
          title={<div style={{textAlign: 'center', fontSize: "23px", fontWeight: 'bold'}}>Generate Commission Report</div>}
          open={this.state.isCommissionReportModalOpen}
          onCancel={this.handleCommissionReportCancel}
          width={500}
          footer={[
            <Button key="cancel" onClick={this.handleCommissionReportCancel}>
              Cancel
            </Button>,
            <Button 
              key="generate" 
              type="primary" 
              loading={this.state.loading}
              onClick={this.generateCommissionReport}
            >
              Generate Report
            </Button>
          ]}
        >
          <div style={{ padding: '20px 0' }}>
            <p style={{ marginBottom: '16px', fontSize: '16px' }}>
              Select a month from the last 12 months to generate the commission report:
            </p>
            <DatePicker
              picker="month"
              placeholder="Select Month"
              style={{ width: '100%' }}
              value={this.state.selectedCommissionMonth ? moment(this.state.selectedCommissionMonth, 'YYYY-MM') : (() => {
                const currentDay = moment().date();
                if (currentDay >= 18) {
                  return moment().subtract(1, 'months');
                } else {
                  return moment().subtract(2, 'months');
                }
              })()}
              onChange={this.handleCommissionMonthChange}
              disabledDate={(current) => {
                // Calculate the latest available month based on current day
                const currentDay = moment().date();
                let latestAvailableMonth;
                
                if (currentDay >= 18) {
                  // If current day is 18th or greater, last month is available
                  latestAvailableMonth = moment().subtract(1, 'months').endOf('month');
                } else {
                  // If current day is before 18th, last month of previous month is available
                  latestAvailableMonth = moment().subtract(2, 'months').endOf('month');
                }
                
                // Disable dates older than 12 months from the latest available month or future dates beyond latest available
                const twelveMonthsFromLatest = moment(latestAvailableMonth).subtract(11, 'months').startOf('month');
                
                return current && (current < twelveMonthsFromLatest || current > latestAvailableMonth);
              }}
            />
            {this.state.emdInfo && (
              <p style={{ marginTop: '16px', color: '#666' }}>
                Report will be generated for: <strong>{this.state.emdInfo.firm}</strong>
              </p>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(PortfolioEMD);
